import React from 'react';
import NewUserCard from '../components/NewUserCard';

const newUser = () => {
  return (
    <div className='login-page'>
        <div className='login-container'>
            <NewUserCard/>
        </div>
    </div>
  );
};

export default newUser;